import { render, staticRenderFns } from "./TitleMore.vue?vue&type=template&id=649cff2e"
import script from "./TitleMore.vue?vue&type=script&lang=js"
export * from "./TitleMore.vue?vue&type=script&lang=js"
import style0 from "./TitleMore.vue?vue&type=style&index=0&id=649cff2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports